import round from './round';

// return two decimal places rounded number
export default ({ width, height }) => round(width / height, 2);
